<template>
  <li
    v-if="this.block"
    class="list-bloc left"
    :class="blockClasses"
    :style="blockStyles"
    :key="i"
  >
    <Observer :name="this.block.row == 1 && this.block.col == 4 ? '' : 'fade-up'" @enter.once="callEditoGTM('eePromoView', i)">
      <div
        class="bloc"
        :class="{
          '-video': this.block.video.url
        }"
      >
        <div
          class="bloc-content"
          :style="blocContentStyles"
          :class="{
            '-video': this.block.video.url
          }"
        >
          <span
            class="bloc-title"
            v-if="this.block.title"
            v-text="this.block.title"
          ></span>
          <p
            class="bloc-description"
            v-if="this.block.description"
            v-html="this.block.description"
          ></p>
          <router-link
            v-if="this.block.ctaLink && !this.block.ctaLink.includes('tel:')"
            :class="ctaClasses"
            :to="this.block.ctaLink"
            @click.native="callEditoGTM('eePromoClick', i)"
          >
            {{ this.block.ctaLabel }}</router-link
          >
          <a
            v-else-if="this.block.ctaLink"
            :class="ctaClasses"
            :href="this.block.ctaLink"
            @click.native="callEditoGTM('eePromoClick', i)"
            >{{ this.block.ctaLabel }}</a
          >
        </div>
        <div
          class="bloc-visual"
          :class="{
            '-video': this.block.video.url
          }"
        >
          <template v-if="!this.block.video.url">
            <router-link
              class="bloc-visual-link"
              v-if="this.block.ctaLink && !this.block.ctaLink.includes('tel:')"
              :to="this.block.ctaLink"
              :aria-label="this.block.ctaLabel ? this.block.ctaLabel : ''"
              @click.native="callEditoGTM('eePromoClick', i)"
            >
              <lazy-picture
                :item="this.block"
                preserve-ratio="true"
              ></lazy-picture>
            </router-link>
            <lazy-picture
              v-else
              :item="this.block"
              preserve-ratio="true"
            ></lazy-picture>
          </template>
          <template v-else>
            <transition name="showPlyr">
              <video-player
                ref="player"
                :in-modal="true"
                :launch="launchVideo === i"
                :item="currentVideo"
                play-fullscreen="false"
                v-if="currentVideo === this.block.video"
              >
              </video-player>
            </transition>
            <template v-if="currentVideo !== this.block.video">
              <img
                :src="this.block.visual"
                :alt="this.block.title || this.block.description"
              />
              <template v-if="this.block.col < 3">
                <span
                  class="bloc-title"
                  v-if="this.block.title"
                  v-text="this.block.title"
                >
                </span>
                <p
                  class="bloc-description"
                  v-if="this.block.description"
                  v-html="this.block.description"
                ></p>
                <router-link
                  class="link-light"
                  v-if="this.block.ctaLink"
                  :to="this.block.ctaLink"
                  @click.native="callEditoGTM('eePromoClick', i)"
                >
                  {{ this.block.ctaLabel }}</router-link
                >
              </template>
              <button
                type="button"
                role="button"
                @click.prevent="playVideo(block, i)"
              >
                {{ $t('Play') }}
              </button>
            </template>
          </template>
        </div>
      </div>
    </Observer>
  </li>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import LazyPicture from './utils/LazyPicture'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  props: ['block', 'i'],
  name: 'PlpEditorialBlock',
  mixins: [ReadyHook],
  components: {
    LazyPicture,
    VideoPlayer: () =>
      import(/* webpackChunkName: "video-player" */ './VideoPlayer')
  },
  data() {
    return {
      currentVideo: null,
      launchVideo: false
    }
  },
  computed: {
    item() {
      return this.items && this.items[0] ? this.items[0] : {}
    },
    localizedUrl() {
      const { url } = currentStoreView()
      return url || ''
    },
    ctaClasses() {
      return {
        'link-light': this.block.ctaStyle === 'Light',
        'btn -small': this.block.ctaStyle !== 'Light'
      }
    },
    blocContentStyles() {
      return {
        color: this.block.textColor === 'black' ? '#000' : '#fff',
        'text-align': this.block.textAlign
      }
    },
    blockStyles() {
      return {
        'grid-column': this.block.position <= (5 - this.block.col) ? `${this.block.position} / span ${this.block.col}` : `1 / span ${this.block.col}`,
        'grid-row': this.block.row

      }
    },
    blockClasses() {
      return {
        'mobile-50': this.block.col === 1,
        'bloc-h': !this.block.overlay
      }
    }
  },
  methods: {
    callEditoGTM(event, i) {
      let edito = this.block
      if (edito) {
        let data = {
          event: event,
          promotion: {
            creative: 'PLP Edito',
            id: 'PLP_edito_' + edito.position,
            name: edito.title,
            position: edito.position
          }
        }
        this.$gtm.trackEvent(data)
        if (edito.ctaLink) {
          data.nextPageVisited = edito.ctaLink
        }
      }
    },
    playVideo(item, position) {
      this.currentVideo = item.video
      if (this.currentVideo) {
        setTimeout(() => {
          this.launchVideo = position
        }, 600)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

.content .list-bloc {
  position: relative;
  margin-bottom: 3rem;
  @include bp(max md) {
    grid-column: 1 / 3 !important;
    &.mobile-50 {
      grid-column: 1 / 2 !important;
    }
  }

  /deep/ .obs {
    height: 100%;
  }

  &.mobile-50:not(.bloc-h) {
    .bloc {
      padding: 6rem 2rem 2rem;
      .btn {
        width: 100%;
        @include bp(max md) {
          margin: 0;
          padding: 20px;
        }
      }
    }
  }

  .bloc {
    position: relative;
    height: 100%;
    display: flex;
    color: var(--zenith-theme-primary);

    @include bp(max md) {
      flex-wrap: wrap;
      padding: 4rem 2rem;
      text-align: center;
      min-height: calc((100vw - 3rem) / 1.77777778);
    }

    &-title {
      display: block;
      font-size: em(10);
      letter-spacing: em(0.4, 10);
      margin-bottom: 2rem;
      text-transform: uppercase;
    }

    &-description {
      font-size: em(28);
      line-height: em(30, 28);
      margin-bottom: 2rem;
    }

    &-content {
      width: calc(25% + 1rem);
      padding: 6rem 2rem 6rem 0;
      background: var(--zenith-white);

      @include bp(max lg) {
        width: calc(50% + 3rem);
      }
      @include bp(max md) {
        width: 100%;
        padding: 0;
        *:first-child {
          padding-top: 2rem;
        }
        *:last-child {
          margin-bottom: 4rem;
        }
      }
    }

    &-visual {
      position: relative;
      width: 75%;
      overflow: hidden;
      &-link {
        height: inherit;
      }

      @include bp(max lg) {
        width: 50%;
      }
      @include bp(max md) {
        width: 100%;
        height: 60vw;
      }

      img,
      /deep/ .-modal {
        position: absolute;
        margin: 0;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%);
        object-fit: cover;
        display: flex;
        align-items: center;

        .plyr {
          margin: 0;
        }

        @include bp(max md) {
          display: block;
        }

        .fade-up-enter,
        .fade-up-leave-to {
          transform: translate(0) !important;
        }
      }

      button {
        position: relative;
        z-index: 20;
        min-width: 8rem;
        height: 8rem;
        padding: 0 1rem;
        border: none;
        display: flex;
        background: none;
        align-items: center;
        justify-content: center;
        color: var(--zenith-theme-primary);
        font-size: em(16);
        letter-spacing: em(1, 16);
        line-height: em(24, 16);

        &:nth-child(2) {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        &:before {
          display: block;
          content: '';
          position: absolute;
          z-index: -1;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 100%;
          background: var(--zenith-white);
          width: 100%;
          height: 0;
          padding-top: 100%;
          transition: all 0.2s ease-in-out;
        }

        &:hover,
        &:focus {
          color: var(--zenith-white);
          &:before {
            background: var(--zenith-theme-primary);
          }
        }

        @include bp(max md) {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      &.-video {
        &:before {
          display: none;
          content: '';
          z-index: 10;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 50%;
          opacity: 0.5;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            #000000 100%
          );
        }
      }

      &-link {
        display: block;

        @include bp(max md) {
          pointer-events: all;
        }
      }
    }
    &-visual {
      /deep/ img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &.-video {
      @include bp(max lg) {
        padding: 0 !important;
        min-height: 60vw;
      }
      .bloc-visual.-video {
        .link-light,
        span,
        p {
          position: relative;
          z-index: 20;

          @include bp(max md) {
            display: none;
          }
        }
      }
    }
  }

  &.bloc-h {
    .bloc {
      min-height: 50rem;

      @include bp(max lg) {
        padding: 0;
        min-height: 60vw;
      }
    }
  }

  &:not(.bloc-h) {
    .bloc {
      padding: 6rem 4rem;
      flex-direction: column;
      justify-content: flex-end;
      min-height: 30rem;

      @include bp(max md) {
        padding: 6rem 2rem;
      }

      &-content {
        position: relative;
        z-index: 10;
        width: 100%;
        background: none;
        padding: 0;

        &.-video {
          display: none;
          @include bp(max md) {
            display: block;
          }
        }
      }

      &-visual {
        position: absolute;
        z-index: 5;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        &.-video {
          padding: 6rem 4rem;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-start;

          .link-light {
            margin-bottom: 2rem;
            margin-right: 0;
          }

          @include bp(max md) {
            position: relative;
            height: 60vw;
            padding: 0;
          }
        }
      }
    }

    &.-light {
      .bloc {
        color: var(--zenith-white);
      }

      .link-light {
        color: var(--zenith-white);

        &:before {
          background: var(--zenith-white);
        }
      }

      @include bp(max md) {
        .bloc.-video {
          color: var(--zenith-theme-primary);
          .link-light {
            color: var(--zenith-theme-primary);
            &:before {
              background: var(--zenith-theme-primary);
            }
          }
        }
      }
    }

    &.-dark {
      .bloc {
        color: var(--zenith-theme-primary);
      }

      .link-light {
        color: var(--zenith-theme-primary);

        &:before {
          background: var(--zenith-theme-primary);
        }
      }
    }
  }
}
</style>
